import { useQuery } from "react-query";
import getIndonesiaCities, {
  IndonesiaCity,
} from "../services/getIndonesiaCities";

interface UseGetIndonesiaCitiesQueryParams {
  stateId: string | null;
  token: string;
}

/**
 * Hook to fetch Indonesian cities with caching (Query-based)
 * Cities are cached per stateId to avoid repeated API calls
 * Cache is valid for 30 minutes (staleTime) and kept for 1 hour (cacheTime)
 *
 * Use this when you want automatic fetching when stateId changes
 */
export function useGetIndonesiaCitiesQuery({
  stateId,
  token,
}: UseGetIndonesiaCitiesQueryParams) {
  return useQuery<IndonesiaCity[], Error>(
    ["GET_INDONESIA_CITIES", stateId],
    () => getIndonesiaCities({ stateId: stateId!, token }),
    {
      enabled: !!stateId && !!token,
      staleTime: 30 * 60 * 1000, // 30 minutes - data won't refetch if fresh
      cacheTime: 60 * 60 * 1000, // 1 hour - keep in cache even when unused
      retry: 2,
      refetchOnWindowFocus: false,
    }
  );
}

export default useGetIndonesiaCitiesQuery;
